import axios from "axios";
import { toast } from "react-toastify";
import setAuthToken from "../../helpers/setAuthToken";
import { URLDevelopment } from "../../helpers/URL";

/* ================= TYPES ================= */
const REGISTER_SUCCESS = "REGISTER_SUCCESS";
const REGISTER_FAIL = "REGISTER_FAIL";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAIL = "LOGIN_FAIL";
const USER_LOADED = "USER_LOADED";
const AUTH_ERROR = "AUTH_ERROR";
const LOGOUT = "LOGOUT";
const SET_LOADING = "SET_LOADING";

/* ================= STATE ================= */
const initialState = {
  token: localStorage.getItem("token"),
  isAuthenticated: !!localStorage.getItem("token"),
  loading: false,
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null,
  registerSuccess: false,
};

/* ================= REDUCER ================= */
const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_LOADING:
      return { ...state, loading: true };

    case REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        registerSuccess: true,
      };

    case REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        registerSuccess: false,
      };

    case LOGIN_SUCCESS:
      localStorage.setItem("token", payload.token);
      localStorage.setItem("user", JSON.stringify(payload.user));
      setAuthToken(payload.token);

      return {
        ...state,
        token: payload.token,
        user: payload.user,
        isAuthenticated: true,
        loading: false,
        registerSuccess: false, // reset
      };

    case USER_LOADED:
      localStorage.setItem("user", JSON.stringify(payload)); // 🔥 fix

      return {
        ...state,
        user: payload,
        isAuthenticated: true,
        loading: false,
      };

    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setAuthToken(null);

      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        registerSuccess: false,
      };

    default:
      return state;
  }
};

export default authReducer;

/* ================= ACTIONS ================= */

/* ✅ Load user on refresh */
export const loadUser = () => async (dispatch) => {
  if (!localStorage.token) {
    dispatch({ type: AUTH_ERROR });
    return;
  }

  setAuthToken(localStorage.token);

  try {
    const res = await axios.get(`${URLDevelopment}/api/user`);
    dispatch({ type: USER_LOADED, payload: res.data });
  } catch (err) {
    dispatch({ type: AUTH_ERROR });
  }
};

/* 🔐 Register (OTP only) */
export const register = ({ name, email, password }) => async (dispatch) => {
  dispatch({ type: SET_LOADING });

  try {
    await axios.post(`${URLDevelopment}/api/user/register`, {
      name,
      email,
      password,
    });

    dispatch({ type: REGISTER_SUCCESS });
    toast.success("OTP sent to your email");
  } catch (err) {
    toast.error(err.response?.data?.message || "Registration failed");
    dispatch({ type: REGISTER_FAIL });
  }
};

/* 🔓 Login */
export const login = ({ email, password }, navigate) => async (dispatch) => {
  dispatch({ type: SET_LOADING });

  try {
    // clear old token
    delete axios.defaults.headers.common["Authorization"];

    const res = await axios.post(
      `${URLDevelopment}/api/user/login`,
      { email, password },
      { headers: { "Content-Type": "application/json" } }
    );

    dispatch({ type: LOGIN_SUCCESS, payload: res.data });

    // ✅ SMART REDIRECT (fix)
    if (navigate) {
      if (res.data.user.role === "admin") {
        navigate("/admin/dashboard");
      } else {
        navigate("/"); // go to shop/home
      }
    }

    toast.success("Login successful");
  } catch (err) {
    toast.error(err.response?.data?.message || "Login failed");
    dispatch({ type: LOGIN_FAIL });
  }
};

/* 🚪 Logout */
export const logout = (navigate) => (dispatch) => {
  dispatch({ type: LOGOUT });

  toast.info("Logged out");

  if (navigate) navigate("/login");
  else window.location.href = "/login";
};